module.exports = __webpack_public_path__ + "img/addPhoto.51b65077.svg";